import(/* webpackMode: "eager" */ "D:\\HM-Work\\Gitee\\mxn2026-web2\\keyboard-keyverse-st63\\app\\globals.css");
import(/* webpackMode: "eager" */ "D:\\HM-Work\\Gitee\\mxn2026-web2\\keyboard-keyverse-st63\\app\\providers.tsx")